<template>
    <datepicker :placeholder="placeholder ? placeholder : ''"
                :format="format? format :'DD/MM/YYYY'"
                :monday-first="true"
                :full-month-name="true"
                wrapper-class="currency-datepicker__wrapper mb-3"
                :class="{input_red_shadow: hasError}"
                input-class="currency-datepicker__input"
                calendar-class="currency-datepicker__element bottom-100"
                v-model="localDate"
                :disabled="disabled"
                :highlighted="localDate ? '' : highlightedConfig"
    />
</template>

<script>
    import Datepicker from '@/components/DatepickerCustom/src/components/Datepicker';

    export default {
        name: "CustomDatepicker",
        components: {Datepicker},
        props: {
            date: {
                required: true,
            },
            placeholder: {},
            format: {},
            hasError: {
                type: Boolean,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false,
            }
        },
        watch: {
            localDate() {
                this.$emit('update:date', this.localDate);
            },
            date() {
                this.localDate = this.date;
            }
        },
        data() {
            return {
                localDate: this.date,
                highlightedConfig: {
                    dates: [new Date()],
                }
            }
        },
    }
</script>



// WEBPACK FOOTER //
// src/components/CustomInputs/CustomDatepicker.vue